<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import ActionMenu from "../../components/ActionMenu.svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import DossierStatusDropdown from "../../components/Business/DossierStatusDropdown.svelte";
  import DossierTypeDropdown from "../../components/Business/DossierTypeDropdown.svelte";
  import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { IDossier } from "../../entities/dossier";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { formatCurrency } from "../../utils/date-utils";
  import { bulkChangeInvoicingStatus, initDetail, record, save, stats } from "./dossier.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.title != "";
  $: protocolNumber = isNew ? "(da assegnare)" : $record != null ? $record.protocol : "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IDossier> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/dossier/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/dossier`);
  }

  onMount(() => initDetail(oid));
</script>

{#if $record}
  <div class="columns">
    <div class="column is-9">
      <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <div class="column is-8">
            <FormField>
              <CustomerDropdown name="Cliente" required={true} bind:value={$record.customerId} />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
              <Input name="Protocollo" disabled={true} value={protocolNumber} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <FormField>
              <DossierTypeDropdown name="Causale Pratica" required={true} bind:value={$record.dossierTypeId} />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
              <DossierStatusDropdown name="Stato" required={true} bind:value={$record.dossierStatusId} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <FormField>
              <Input name="Descrizione aggiuntiva" placeholder="descrizione aggiuntiva" required={true} bind:value={$record.title} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <!--
            <div class="column">
              <FormField>
                <NumberInput
                  name="Anno Inizio"
                  placeholder="anno inizio"
                  maxValue={$record.endYear}
                  disabled={!isNew}
                  required={true}
                  bind:value={$record.startYear}
                />
              </FormField>
            </div>
            <div class="column">
              <FormField>
                <NumberInput
                  name="Anno Fine"
                  placeholder="anno fine"
                  required={true}
                  minValue={$record.startYear}
                  bind:value={$record.endYear}
                />
              </FormField>
            </div>
            -->

          <div class="column">
            <FormField>
              <DateInput name="Data Inizio" placeholder="inizio" disabled={!isNew} required={true} bind:value={$record.startDate} />
            </FormField>
          </div>

          <div class="column">
            <FormField>
              <DateInput name="Data Effetto" placeholder="" required={true} bind:value={$record.effectDate} />
            </FormField>
          </div>

          <div class="column">
            <FormField>
              <DateInput name="Data Scadenza" placeholder="" required={true} bind:value={$record.deadlineDate} />
            </FormField>
          </div>

          <div class="column">
            <FormField>
              <DateInput name="Data Fine" placeholder="" required={false} bind:value={$record.endDate} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <FormField>
              <Textarea name="Note" placeholder="note" required={false} bind:value={$record.notes} />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
    <div class="column is-3">
      <div class="box">
        <h1 class="subtitle">Riepilogo</h1>
        {#if $stats}
          <p>Tempo totale: {$stats.totalTime}</p>
          <p>Tempo medio attività: {$stats.avgActivityTime}</p>
          <p>Costi anticipati: {formatCurrency($stats.costsAmount)}</p>
          <p>Numero attività: {$stats.numActivities}</p>
          <p>Numero utenti: {$stats.numUsers}</p>
          <p>&nbsp;</p>

          <UserTimeStats entries={$stats.topUsers} />
        {:else}
          <p>Tempo totale: --:--</p>
          <p>Tempo medio attività: --:--</p>
          <p>Costi anticipati: € 0.00</p>
          <p>Numero attività: 0</p>
          <p>Numero utenti: 0</p>
        {/if}
      </div>

      {#if !isNew}
        <ActionMenu title="Modifica stato fatturazione">
          <a href="#top" class="dropdown-item" on:click={(_) => bulkChangeInvoicingStatus(true)}>Tutte fatturate</a>
          <a href="#top" class="dropdown-item" on:click={(_) => bulkChangeInvoicingStatus(false)}>Tutte da fatturare</a>
        </ActionMenu>
      {/if}
    </div>
  </div>
{/if}
